import { IWizardStep } from "../../../../wizard/types";
import Content from "./Content";

export const viewContentConfig: IWizardStep = {
  width: "568px",
  titleConfig: {
    titleText: "View program",
    info: "You can see all the completed steps but you can not edit them.",
  },
  content: Content,
  stepName: "step5",
};
